import TrainingSummaryPage from "./Player/TrainingSummaryPage";

/**
 * iOS-style training summary for players and coaches.
 * Coaches pick a player (with HR) in-page when multiple players have data.
 */
export default function TrainingSummaryRoute() {
  return <TrainingSummaryPage />;
}
